var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon15BlogCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7 4.7a1 1 0 0 0-1.4-1.4L12 10.58l-7.3-7.3A1 1 0 0 0 3.3 4.7l7.28 7.3-7.3 7.3a1 1 0 1 0 1.42 1.4l7.3-7.28 7.3 7.3a1 1 0 0 0 1.4-1.42L13.42 12l7.3-7.3z",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxwYXRoIGQ9Ik0yMC43IDQuN2ExIDEgMCAwIDAtMS40LTEuNEwxMiAxMC41OGwtNy4zLTcuM0ExIDEgMCAwIDAgMy4zIDQuN2w3LjI4IDcuMy03LjMgNy4zYTEgMSAwIDEgMCAxLjQyIDEuNGw3LjMtNy4yOCA3LjMgNy4zYTEgMSAwIDAgMCAxLjQtMS40MkwxMy40MiAxMmw3LjMtNy4zeiIgZmlsbC1ydWxlPSJldmVub2RkIi8+DQo8L3N2Zz4NCg==";
export { SvgIcon15BlogCross as ReactComponent };